import React from 'react';
import '../less/services-list.less';
import clearBR from "utils/clearBR";
import abank24_img from '../img/abank24_img.png';
import payments_img from '../img/payments_img.png';
import transfers_img from '../img/transfers_img.png';
import mobilepay_img from '../img/mobilepay_img.png';
import safebox_img from '../img/safebox_img.png';
import lising_img from '../img/lising_img.png';
import insurance_img from '../img/insurance_img.png';
import pension_img from '../img/pension_img.png';
import abroad_img from '../img/abroad_img.png';
import personal_data_img from '../img/personal_data_img.png';
import wartime_img from '../img/wartime_img.png';
import cashback_img from '../img/cashback_img.png';
import tso_img from '../img/tso_img.png';
import card_design_img from '../img/card_design_img.png';
import brokerage_services_img from '../img/brokerage_services_img.png';
import e_receipt_img from '../img/e_receipt_img.png';
import benefits_military_personnel_img from '../img/benefits_military_personnel_img.webp';
import DOMPurify from 'utils/sanitize';

export default function template() {
    const isMobile = this.isViewportMobile(),
      itemsData = [
        {
          title: 'SERVICE_MAIN_ABANK',
          text: 'SERVICE_MAIN_ABANK_HINT',
          img: abank24_img,
          link: '/services/abank',
          id: '0'
        },
        {
          title: 'SERVICE_MAIN_PAYMENTS',
          text: 'SERVICE_MAIN_PAYMENTS_HINT',
          img: payments_img,
          link: '/services/payments',
          id: '1'
        },
        {
          title: 'SERVICE_MAIN_TRANSFERS',
          text: 'SERVICE_MAIN_TRANSFERS_HINT',
          img: transfers_img,
          link: '/services/transfers',
          id: '2'
        },
        {
          title: 'SERVICE_MAIN_MOBILE_PAY',
          text: 'SERVICE_MAIN_MOBILE_PAY_HINT',
          img: mobilepay_img,
          link: '/services/mobilepay',
          id: '3'
        },
        {
          title: 'SERVICE_MAIN_SAFE',
          text: 'SERVICE_MAIN_SAFE_HINT',
          img: safebox_img,
          link: '/services/safe_boxes',
          id: '4'
        },
        {
          title: 'SERVICE_MAIN_LEASING',
          text: 'SERVICE_MAIN_LEASING_HINT',
          img: lising_img,
          link: '/services/auto-leasing',
          id: '5'
        },
        {
          title: 'SERVICE_MAIN_INSURANCE',
          text: 'SERVICE_MAIN_INSURANCE_HINT',
          img: insurance_img,
          link: '/services/insurance',
          id: '6'
        },
        {
          title: 'SERVICE_MAIN_PENSION',
          text: 'SERVICE_MAIN_PENSION_HINT',
          img: pension_img,
          link: '/services/pension',
          id: '7'
        },
        {
          title: 'PERSONAL_DATA_BREADCRUMBS',
          text: '',
          img: personal_data_img,
          link: '/services/personal_data',
          id: '8'
        },
        {
          title: 'SERVICE_PREVIEW_ABROAD_TITLE',
          text: '',
          img: abroad_img,
          link: '/services/if-you-are-abroad',
          id: '9'
        },
        {
          title: 'SERVICE_PREVIEW_WAR_TIME_TITLE',
          text: '',
          img: wartime_img,
          link: '/services/war-time',
          id: '10'
        },
        {
          title: 'SERVICE_PREVIEW_CASHBACK_TITLE',
          text: '',
          img: cashback_img,
          link: '/services/become-partner',
          id: '11'
        },
        {
          title: 'SERVICE_PREVIEW_TSO_TITLE',
          text: '',
          img: tso_img,
          link: '/self_service_terminal',
          id: '12'
        },
        {
          title: 'SERVICE_PREVIEW_CARD_DESIGN_TITLE',
          text: 'SERVICE_PREVIEW_CARD_DESIGN_TEXT',
          img: card_design_img,
          link: '/services/digital_skins',
          id: '13'
        },
        {
          title: 'SERVICE_PREVIEW_BROKERAGE_SERVICES_TITLE',
          text: 'SERVICE_PREVIEW_BROKERAGE_SERVICES_TEXT',
          img: brokerage_services_img,
          link: '/services/brokerage-services',
          id: '14'
        },
        {
          title: 'SERVICE_PREVIEW_RECEIPT_TITLE',
          text: 'SERVICE_PREVIEW_RECEIPT_TEXT',
          img: e_receipt_img,
          link: '/business/gov/e-receipt',
          id: 'e-receipt'
        },
        {
          title: 'SERVICE_PREVIEW_BENEFITS_MILITARY_PERSONNEL_TITLE',
          text: 'SERVICE_PREVIEW_BENEFITS_MILITARY_PERSONNEL_TEXT',
          img: benefits_military_personnel_img,
          link: '/services/benefits-military-personnel',
          id: 'benefits-military-personnel'
        }
      ]
    const businessItems = itemsData.map(item => {
    const text = isMobile ? clearBR(this.l10n(item.text)) : this.l10n(item.text);
    return (
      <a href={item.link} target='_self' key={item.id} className={`services-list-item services-list-item_${item.id}`}>
        <img className='services-list-item-img' src={item.img} alt="service_list_img" />
        <h2 className='services-list-item-title' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.title))}}></h2>
        <div className='services-list-item-text' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(text))}}></div>
        <div className='services-list-item-more' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('MAIN_PAGE_NEWS_MORE'))}}></div>
      </a>
    )
  });

    return (
      <div className="services-list-module">
        <div className="content">
          <h1 className='services-list-title'>{this.l10n('SERVICE_OUR_SERVICES')}</h1>
          <div className='services-list-text'>{this.l10n('SERVICE_BANNER_SUBTITLE')}</div>
          <div className="services-list">
            {businessItems}
          </div>
        </div>
      </div>
    );
}
